import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  ICreateWithdrawalRequest,
  ICreateWithdrawalRequestResponse,
  ISetAutoWithdrawal,
  ISetAutoWithdrawalResponse,
  IUpdateWithdrawalRequestStatus,
  IWithdrawalRequest,
  IWithdrawalRequestListRequest,
  IWithdrawalRequestListResponse
} from 'models/withdrawalRequest'

export const withdrawalRequestsApi = {
  create(data: ICreateWithdrawalRequest): Promise<AxiosResponse<ICreateWithdrawalRequestResponse>> {
    return privateApi.post<ICreateWithdrawalRequestResponse>('admin/withdrawal-requests', data)
  },

  getList({
    skip,
    limit,
    status,
    seller_id
  }: IWithdrawalRequestListRequest): Promise<AxiosResponse<IWithdrawalRequestListResponse>> {
    const params = new URLSearchParams()
    params.append('skip', skip)
    params.append('limit', limit)

    if (status) {
      params.append('status', status)
    }

    if (seller_id) {
      params.append('seller_id', seller_id)
    }

    return privateApi.get<IWithdrawalRequestListResponse>(
      `admin/withdrawal-requests?${params.toString()}`
    )
  },

  getById(id: string): Promise<AxiosResponse<IWithdrawalRequest>> {
    return privateApi.get<IWithdrawalRequest>(`admin/withdrawal-requests/${id}`)
  },

  updateStatus(
    id: string,
    data: IUpdateWithdrawalRequestStatus
  ): Promise<AxiosResponse<IWithdrawalRequest>> {
    return privateApi.patch<IWithdrawalRequest>(
      `admin/withdrawal-requests/${id}/status`,
      data
    )
  },

  resendEmail(id: string): Promise<AxiosResponse<{ message: string }>> {
    return privateApi.post(`admin/withdrawal-requests/${id}/resend-email`)
  },

  downloadCard(id: string): Promise<AxiosResponse<Blob>> {
    return privateApi.get<Blob>(`admin/withdrawal-requests/${id}/card`, { responseType: 'blob' })
  },

  getMyList({
    skip,
    limit,
    sum
  }: {
    skip: string
    limit: string
    sum?: number
  }): Promise<AxiosResponse<IWithdrawalRequestListResponse>> {
    const params = new URLSearchParams()
    params.append('skip', skip)
    params.append('limit', limit)
    if (sum !== undefined) params.append('sum', String(sum))
    return privateApi.get<IWithdrawalRequestListResponse>(
      `withdrawal-requests/my?${params.toString()}`
    )
  },

  setAutoWithdrawal(data: ISetAutoWithdrawal): Promise<AxiosResponse<ISetAutoWithdrawalResponse>> {
    return privateApi.patch<ISetAutoWithdrawalResponse>('withdrawal-requests/auto-withdrawal', data)
  },

  getMyById(id: string): Promise<AxiosResponse<IWithdrawalRequest>> {
    return privateApi.get<IWithdrawalRequest>(`withdrawal-requests/my/${id}`)
  }
}
